<div class="mib-dialog flex flex-col gap-8" role="dialog">
  <header class="shrink-0">
    <mai-mib-logo></mai-mib-logo>
  </header>
  <div class="">
    <div class="text-center">
      <h2 class="text-2xl max-lg:landscape:text-xl text-branding-primary text-center mb-4">
        Access declined
      </h2>
      <p>You chose not to accept the disclaimer.</p>
      <p>Please review and accept it to access Medinbox AI.</p>
    </div>
  </div>
  <footer class="">
    <mib-button class="w-full" (click)="dialogRef.close()">
      <svg mib-undo-arrow-icon></svg>
      Return to disclaimer
    </mib-button>
  </footer>
</div>
